// Contact.js
import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import {
  faPhoneVolume,
  faEnvelope,
  faArrowUp,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebook,
  faInstagram,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import logo from "../Imges/logo-2.png";
import "./Footer.css";

const Contact = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const section = document.querySelector(".contact-section");
      if (section) {
        const rect = section.getBoundingClientRect();
        setIsVisible(rect.top < window.innerHeight - 100);
      }

      setShowScroll(window.scrollY > 200);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <motion.div
      className="contact-section"
      initial={{ opacity: 0, y: 50 }}
      animate={isVisible ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
      transition={{ duration: 1, ease: "easeOut" }}
    >
      {/* Left Section */}
      <motion.div
        className="contact-left"
        initial={{ opacity: 0, x: -50 }}
        animate={isVisible ? { opacity: 1, x: 0 } : { opacity: 0, x: -50 }}
        transition={{ duration: 0.6, ease: "easeOut", delay: 0.3 }}
      >
        <img src={logo} alt="Divyam Ads company logo" className="contact-logo" />
        <h2>
          OUR GREAT IDEAS <br />
          <motion.span
            initial={{ opacity: 0, scale: 0.8 }}
            animate={isVisible ? { opacity: 1, scale: 1 } : {}}
            transition={{ duration: 0.5, delay: 0.5 }}
          >
            GROW
          </motion.span>
          <br />
          YOUR BUSINESS
        </h2>
      </motion.div>

      {/* Center Section */}
      <motion.div
        className="contact-center"
        initial={{ opacity: 0, y: 50 }}
        animate={isVisible ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
        transition={{ duration: 0.7, ease: "easeOut", delay: 0.5 }}
      >
        <h3>LET’S TALK</h3>
        <p>
          <FontAwesomeIcon icon={faPhoneVolume} />{" "}
          <a href="tel:+919825110526">&nbsp;+91 98251 10526</a>
        </p>
        <p>
          <FontAwesomeIcon icon={faEnvelope} />{" "}
          <a href="mailto:divyamads2014@gmail.com">
            &nbsp; divyamads2014@gmail.com
          </a>
        </p>
        <h3>PHYSICAL ADDRESS</h3>
        <p>
          410, 4th Floor, Proton Plus, Above Croma Showroom, B/h. Star Bazaar,
          Pal, Adajan, Surat 395009, Gujarat, INDIA.
        </p>
      </motion.div>

      {/* Right Section */}
      <motion.div
        className="contact-right"
        initial={{ opacity: 0, x: 50 }}
        animate={isVisible ? { opacity: 1, x: 0 } : { opacity: 0, x: 50 }}
        transition={{ duration: 0.6, ease: "easeOut", delay: 0.7 }}
      >
        <iframe
          title="Divyam Ads Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14693.282216437936!2d72.7688526!3d21.2047285!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x123456789abcdef!2sDivyam%20Ads!5e0!3m2!1sen!2sin!4v1700000000000"
          allowFullScreen
          loading="lazy"
          className="contact-map"
        ></iframe>
        <div className="social-icons">
          <p style={{ color: "white", marginRight: "20px", marginTop: "20px" }}>
            Copyright © 2025 - Divyam Ads
          </p>
          <a
            href="https://facebook.com"
            aria-label="Facebook page"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon icon={faFacebook} />
          </a>
          <a
            href="https://instagram.com"
            aria-label="Instagram page"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon icon={faInstagram} />
          </a>
          <a
            href="https://wa.me/919825110526"
            aria-label="WhatsApp chat"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon icon={faWhatsapp} />
          </a>
        </div>
      </motion.div>

      {/* Scroll-to-Top Button */}
      {showScroll && (
        <motion.button
          className="scroll-to-top"
          onClick={scrollToTop}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
        >
          <FontAwesomeIcon icon={faArrowUp} />
        </motion.button>
      )}
    </motion.div>
  );
};

export default Contact;
